const isSizeType = (obj) => !!obj && typeof obj.width === "number" && typeof obj.height === "number";
export {
  isSizeType
};
//# sourceMappingURL=SizeType.js.map
